import moment from "moment";
import React from "react";
import { formatWrittenDayMonthYear } from "shared/utils/momentutils";
import { SimpleHeader } from "./SimpleHeader";

interface ProductionHeaderProps {
  production: server.dto.Tour
}

export const ProductionHeader = ({ production }: ProductionHeaderProps) => {
  const start = production.startDate ? formatWrittenDayMonthYear(moment.utc(production.startDate)) : "";
  const end = production.endDate ? formatWrittenDayMonthYear(moment.utc(production.endDate)) : "";

  return <SimpleHeader title={production.name} isDeleted={false}>
    {(start || end)
      ? <div className="purple-header-text purple-header-light">
        {start && <div>{start}</div>}
        {end && <div>{RESX.DateTime.UntilAndIncludingAbbreviated} {end}</div>}
      </div>
      : <div className="purple-header-text purple-header-light">{RESX.Show.NoLinkedShows}</div>}
  </SimpleHeader>;
};
